namespace RioERP.Reports {
    export namespace GstReportSummaryWithGstinService {
        export const baseUrl = 'Reports/GstReportSummaryWithGstin';

        export declare function Create(request: Serenity.SaveRequest<GstReportSummaryWithGstinRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<GstReportSummaryWithGstinRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<GstReportSummaryWithGstinRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<GstReportSummaryWithGstinRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Reports/GstReportSummaryWithGstin/Create",
            Update = "Reports/GstReportSummaryWithGstin/Update",
            Delete = "Reports/GstReportSummaryWithGstin/Delete",
            Retrieve = "Reports/GstReportSummaryWithGstin/Retrieve",
            List = "Reports/GstReportSummaryWithGstin/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>GstReportSummaryWithGstinService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
